export default __webpack_public_path__ + "static/media/msf_background_l2.33872129.jpg";